import { CommonModule } from '@angular/common';
//Principais
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
//Models
import { Polo } from 'src/app/shared/models/polo/Polo';
import { Categoria } from "src/app/shared/models/categoria/Categoria";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { Consolidado } from "src/app/shared/models/relatorio/Consolidado";
import { ListarCalculoUsabilidade } from "src/app/shared/models/relatorio/listar-calculo-usabilidade";
import { ListarChamadosUsuario } from 'src/app/shared/models/relatorio/listar-chamado-usuario';
import { ListarConsolidado } from "src/app/shared/models/relatorio/listar-consolidado";
import { ListarOcorrenciasAtivas } from "src/app/shared/models/relatorio/listar-ocorrencias-ativas";
import { ListarVisitaPsicologos } from "src/app/shared/models/relatorio/listar-visita-psicologos";
import { ListarLogVinculoPlanoMelhoria } from "src/app/shared/models/relatorio/listar-log-vinculo-plano-melhoria";
import { ListarStatusPMCE } from "src/app/shared/models/relatorio/listar-status-pmce";
import { StatusPlanoMelhoria } from 'src/app/shared/enums/PlanoMelhoria/StatusPlanoMelhoria';
import { BuscaGeralJornadaItem } from "src/app/shared/models/relatorio/busca-geral-jornada";
import { DiagnosticoDataRegistroOrfaItem, ResumoDiagnosticoDataRegistroOrfa } from "src/app/shared/models/relatorio/diagnostico-data-registro-orfa";
import { DiagnosticoDuplicatasVisitaPrevencaoPocItem, ResumoDiagnosticoDuplicatasVisitaPrevencaoPoc } from "src/app/shared/models/relatorio/diagnostico-duplicatas-visita-prevencao-poc";
import { AtribuicaoLoginSed, PerfilLoginSed, UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
//Services
import { formatDate } from '@angular/common';
import { BreadcrumbComponent } from 'components/breadcrumb/breadcrumb.component';
import { lastValueFrom } from "rxjs";
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { ListarPendencias } from 'src/app/shared/models/relatorio/listar-pendencias';
import { CategoriaService } from "src/app/shared/services/categoria.service";
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { EscolaService } from 'src/app/shared/services/escola.service';
import { CalendarioService } from 'src/app/shared/services/calendario.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { PsicologoService } from 'src/app/shared/services/psicologo.service';
import { RelatorioService } from "src/app/shared/services/relatorio.service";
import { PlanoMelhoriaService } from 'src/app/shared/services/plano-melhoria.service';
import { PlanoMelhoria } from 'src/app/shared/models/plano-melhoria/planoMelhoria';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { ModalComponent } from 'components/modal/modal.component';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';

/** Linha de ação PMCE com pelo menos um campo vazio (consulta somente leitura). */
export interface AcaoPmceCampoVazioItem {
  codigoPlanoMelhoria: number;
  nomeEscola: string;
  codigoPlanoMelhoriaAcao: number;
  temaResumo: string;
  publico: number | null;
  responsavel: string;
  outraParceria: string;
  bimestre: number | null;
  publicoEditavel: boolean;
  responsavelEditavel: boolean;
  outraParceriaEditavel: boolean;
  bimestreEditavel: boolean;
}

@Component({
    selector: 'consolidado',
    templateUrl: './consolidado.component.html',
    styleUrls: ['./consolidado.component.scss'],
    imports:[CommonModule,NgxSpinnerModule,NgSelectModule,BreadcrumbComponent,ReactiveFormsModule,libsCommonImports,ModalComponent],
    standalone: true
})

export class ConsolidadoComponent implements OnInit {

  private get DataAtual (){return new Date()}
  public minDate:string = '2021-01-01' ;
  public maxDate:string = `${this.DataAtual.getFullYear()}-12-30` ;

  // Variaveis de Login
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  public formRelatorios: FormGroup;
  public get form() { return this.formRelatorios.controls; }

  constructor(
    private config: NgSelectConfig,
    private authService: AuthService,
    private spinnerService: NgxSpinnerService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private toastr: ToastrService,
    private relatorioService: RelatorioService,
    private planoMelhoriaService: PlanoMelhoriaService,
    private escolaService: EscolaService,
    private psicologoService:PsicologoService,
    private categoriaService:CategoriaService,
    private excelService: ExcelService,
    private calendarioService: CalendarioService,

    @Inject(LOCALE_ID) private locale: string,
  ){
    // ng-select mudança de texto
    this.config.notFoundText = 'Não encontrado';
    // Dados usuário logado
    this.userLogado = this.authService.getUser();
    if(this.userLogado != null && !this.userLogado.flPsicologo){
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  public polos: Polo[] = [];
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public categorias: Categoria[] = [];
  public usuarios: UserLoginSed[] = [];
  public perfis: PerfilLoginSed[] = [];
  public listaConsolidado: ListarConsolidado[] = [];
  public listaPendencias: ListarPendencias[] = [];
  public listaVisitasPsicologos: ListarVisitaPsicologos[] = [];
  public listaChamadoUsuario: ListarChamadosUsuario[] = [];
  public listaOcorrenciasAtivas: ListarOcorrenciasAtivas[] = [];
  public listaCalculoUsabilidade: ListarCalculoUsabilidade[] = [];
  public listaLogVinculoPlanoMelhoria: ListarLogVinculoPlanoMelhoria[] = [];
  public listaStatusPMCE: ListarStatusPMCE[] = [];
  public resumoDataRegistroOrfa: ResumoDiagnosticoDataRegistroOrfa | null = null;
  public listaDataRegistroOrfa: DiagnosticoDataRegistroOrfaItem[] = [];
  public ativarPainelDataRegistroOrfa = false;
  public showModalConfirmacaoCorrecao = false;
  public resumoDuplicatasPrevencaoPoc: ResumoDiagnosticoDuplicatasVisitaPrevencaoPoc | null = null;
  public listaDuplicatasPrevencaoPoc: DiagnosticoDuplicatasVisitaPrevencaoPocItem[] = [];
  public ativarPainelDuplicatasPrevencaoPoc = false;
  public showModalConfirmacaoInativacaoDuplicatas = false;
  public selecionarTodosDuplicatas = false;
  public incluirAprovadosDuplicatas = false;
  public ativarPainelCorrecaoCamposAcoesPmce = false;
  public ativarBuscaGeralJornada = false;
  public listaBuscaGeralJornada: BuscaGeralJornadaItem[] = [];
  public listaAcoesPmceCamposVazios: AcaoPmceCampoVazioItem[] = [];
  public publicoOpcoesPmce = [
    { id: 1, name: 'Estudantes' },
    { id: 2, name: 'Professores' },
    { id: 3, name: 'Equipe gestora' },
    { id: 4, name: 'Outros servidores/funcionários' },
    { id: 5, name: 'Famílias e responsáveis' },
    { id: 6, name: 'Equipe de apoio escolar (AOE)' },
  ];
  public bimestreOpcoesPmce = [
    { id: 1, name: '1º Bimestre' },
    { id: 2, name: '2º Bimestre' },
    { id: 3, name: '3º Bimestre' },
    { id: 4, name: '4º Bimestre' },
  ];
  public ativarCamposUsuario = false;
  public ativarCamposPsicologo = false;
  public ativarCamposOcorrenciasAtivas = false;
  public ativarCampoDivergenciaPmce = false;
  public ativarCampoStatusPmce = false;
  public ativarCampoPeriodo = true;
  public ativarCampoPolo = true;
  public ativarCamposDiretoriaEscola = true;
  public flagAtivo = [ { id: true, name: 'Sim' }, { id: false, name: 'Não' }];
  public statusPlanoMelhoriaOptions = [
    { id: StatusPlanoMelhoria.Novo, name: 'Novo' },
    { id: StatusPlanoMelhoria.AguardandoValidacaoSupervisor, name: 'Aguardando Validação Supervisor de Ensino' },
    { id: StatusPlanoMelhoria.AguardandoValidacaoPecConviva, name: 'Aguardando Validação PEC CONVIVA' },
    { id: StatusPlanoMelhoria.DevolvidoAjustes, name: 'Devolvido para ajustes' },
    { id: StatusPlanoMelhoria.Aprovado, name: 'Aprovado' },
  ];
  public relatorios: any[] = [];

  public ngOnInit(): void {

    this.formRelatorios = new FormGroup({
      codigoPolo: new FormControl(null),
      codigoDiretoria: new FormControl(null),
      codigoEscola: new FormControl(null),
      codigoSubCategoria: new FormControl(null),
      codigoPerfil: new FormControl(null),
      cpf: new FormControl(null),
      dataInicio: new FormControl(null),
      dataFim: new FormControl(null),
      codigoAtivo: new FormControl(null),
      somenteDivergencia: new FormControl(false),
      statusPlanoMelhoria: new FormControl(null),
      codigoJornada: new FormControl(null),
      cpfBusca: new FormControl(null),
      codigoEscolaLivre: new FormControl(null),
      codigoDiretoriaLivre: new FormControl(null),
      idRelatorio: new FormControl(null)
    });

    const objConsolidado = { id: "relatorioGeral", name: 'Relatório Consolidado Geral' };
    const objPendencias = { id: "relatorioPendencias", name: 'Relatório Pendências' };
    const objVisita = { id: "relatorioVisitaPsicologo", name: 'Relatório Visita Psicólogo' };
    const objUsuario = { id: "relatorioChamadoUsuario", name: 'Relatório Chamados por Usuario' };
    const objOcorrencias = { id: "relatorioOcorrenciasAtivas", name: 'Relatório Ocorrências Ativas/Excluídas' };
    const objCalculo = { id: "relatorioCalculoUsabilidade", name: 'Relatório Cálculo Usabilidade' };
    const objLogsVinculo = { id: "relatorioLogVinculoPlanosPMCE", name: 'Relatório Logs Vinculo PMCE' };
    const objStatusPMCE = { id: "relatorioStatusPMCE", name: 'Relatório Status PMCE + Evidências' };
    const objDataRegistroOrfa = { id: "correcaoDataRegistroOrfa", name: 'Correção Data Registro (Acolhimento Agendado)' };
    const objDuplicatasPrevencaoPoc = { id: "duplicadosVisitaPrevencaoPoc", name: 'Duplicados Visita Prevenção POC' };
    const objCorrecaoCamposAcoesPmce = { id: "correcaoCamposAcoesPmce", name: 'Diagnóstico campos vazios ações PMCE' };
    const objBuscaGeralJornada = { id: "buscaGeralJornada", name: 'Busca geral de jornada' };
    if(this.userLogado?.funcionalidades.includes(17) || this.userLogado?.funcionalidades.includes(20)){
      this.relatorios.push(objConsolidado);
      this.relatorios.push(objPendencias);
    }
    if(this.userLogado?.funcionalidades.includes(17)){
      this.relatorios.push(objVisita);
      this.relatorios.push(objBuscaGeralJornada);
      this.relatorios.push(objUsuario);
      this.relatorios.push(objOcorrencias);
      this.relatorios.push(objCalculo);
      this.relatorios.push(objLogsVinculo);
      this.relatorios.push(objStatusPMCE);
      this.relatorios.push(objDataRegistroOrfa);
      if (this.userLogado?.codigoPerfil == Perfil.GestorConviva) {
        this.relatorios.push(objDuplicatasPrevencaoPoc);
        this.relatorios.push(objCorrecaoCamposAcoesPmce);
      }
    }
    if (this.userLogado?.codigoPolo) {
      this.formRelatorios.get('codigoPolo')?.setValue(this.userLogado.codigoPolo);
    }

    this.getPolos().then(() => {
      if (this.userLogado?.codigoPolo) {
        this.formRelatorios.get('codigoPolo')?.setValue(this.userLogado.codigoPolo);
      }

      this.ativaPolo();
      this.getCategorias();

      // if (this.userLogado?.flPsicologo) {
      //   this.getDiretoriasPerfilDiretoria();
      // } else {
      //   if (this.atribuicoesLogin.NumeroComportamento == 1) {
      //     this.getDiretorias();
      //   }
      //   if (this.atribuicoesLogin.NumeroComportamento == 2) {
      //     this.getDiretoriasPerfilDiretoria();
      //   }
      //   if (this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
      //     this.getDiretoriasPerfilEscola();
      //   }
      // }
    });
  }

  public async getPolos() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getPolos())
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polos = response.data;

    if (this.userLogado?.codigoPolo) {
      this.formRelatorios.get('codigoPolo')?.setValue(this.userLogado.codigoPolo);
    }

    this.ativaPolo();

    this.spinnerService.hide();
  }

  public ativaPolo() {
    const codigoPolo = this.formRelatorios.get('codigoPolo')?.value;

    if (codigoPolo && this.polos?.length > 0) {
      const existPolo = this.polos.find(p => p.codigoPolo == codigoPolo);
      if (existPolo) {
        this.formRelatorios.get('codigoPolo')?.setValue(codigoPolo, { emitEvent: false });
      }
    }

    // if (this.userLogado) {
    //   this.authService.setUser(this.userLogado);
    // }
  }

  public async OnChangePolo() {
    const codigoPolo = this.formRelatorios.get('codigoPolo')?.value;

    // if (this.userLogado) {
    //   this.userLogado.codigoPolo = codigoPolo ?? 0;
    //   this.authService.setUser(this.userLogado);
    // }

    this.zerarDiretoria();
    this.zerarEscola();

    if (codigoPolo) {
      await this.getDiretoriasPorPolo(codigoPolo);
    }
  }

  public async getDiretoriasPorPolo(codigoPolo: number) {

    this.zerarDiretoria();
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.psicologoService.getDiretoriaPorPolo(codigoPolo)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;

    this.formRelatorios.get('codigoDiretoria')?.enable();

    this.ativaDiretoria();
    this.getEscolas(true);

    this.spinnerService.hide();
  }


  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);
    });

    if(this.diretorias.length == 1){
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      this.getEscolas(true);
    }else {
      this.ativaDiretoria();
      this.getEscolas(true);
    }
  }

  public async getDiretorias() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.diretorias = response.data;
    this.spinnerService.hide();
    if(this.userLogado?.codigoDiretoria != undefined){
      this.ativaDiretoria();
      this.getEscolas(true);
    }
  }

  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
    });

    if(this.diretorias.length == 1 && this.escolas.length == 1){
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();

      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      this.form.codigoEscola.disable();
    }

    if(this.diretorias.length == 1 && this.escolas.length > 1){
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    }
    this.ativaDiretoria();
    this.ativaEscola();
  }

  public async getEscolas(diretoriaLogada:boolean = false) {
    const codigoDE = this.userLogado?.codigoDiretoria != undefined && diretoriaLogada ? this.userLogado?.codigoDiretoria : this.formRelatorios.get('codigoDiretoria')?.value;
    if(this.userLogado?.flPsicologo){
      this.zerarEscola();
      if (codigoDE != null) {
        this.spinnerService.show();

        var response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
        if(!response.isSucess){
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }
        this.escolas = response.data;
        this.spinnerService.hide();
      }
      //this.ativaEscola();
    }else
    if(this.atribuicoesLogin.NumeroComportamento == 1 || this.atribuicoesLogin.NumeroComportamento == 2){
      this.zerarEscola();
      if (codigoDE != null) {
        this.spinnerService.show();

        var response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
        if(!response.isSucess){
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }
        this.escolas = response.data;
        this.spinnerService.hide();
        //this.ativaEscola();
      }
    }
    // if(this.userLogado !== null)
    // {
    //   this.userLogado.codigoDiretoria = codigoDE == null ? 0 : codigoDE;
    //   this.authService.setUser(this.userLogado);
    // }
  }

  public ativaDiretoria() {
    if (this.userLogado?.codigoDiretoria) {
      const exist = this.diretorias.find(d => d.codigoDiretoria == this.userLogado!.codigoDiretoria);
      if (exist) {
        this.formRelatorios.get('codigoDiretoria')?.setValue(this.userLogado.codigoDiretoria);

        //this.getEscolas(true);
      }
    }

    // if (this.userLogado) {
    //   this.authService.setUser(this.userLogado);
    // }
  }

  public ativaEscola(){
    if(this.userLogado?.codigoEscola != undefined){
      const existEscola = this.escolas.find(s=>s.codigoEscola == this.userLogado?.codigoEscola);
      if(existEscola != undefined){
        this.formRelatorios.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola);
      }
    }
    // if(this.userLogado !== null)
    //   this.authService.setUser(this.userLogado);
  }


  public zerarDiretoria() {
    this.diretorias = [];
    this.formRelatorios.get('codigoDiretoria')?.patchValue(null);
  }

  public zerarEscola() {
    this.escolas = [];
    this.formRelatorios.get('codigoEscola')?.patchValue(null);
  }

  public async getCategorias() {
    if(this.ativarCamposUsuario || this.ativarCamposPsicologo || this.ativarCamposOcorrenciasAtivas){

      if(this.form?.dataInicio.value != null)
      {
        await this.getPerfis();
        await this.getUsuarios();
      }
      else
        await this.getUsuarios();

      this.spinnerService.show();
      const result = await lastValueFrom(this.categoriaService.getCategoriasWithSub(0))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
      if(!result.isSucess){
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.categorias = result.data;
      this.spinnerService.hide();
    }
  }

  public async getUsuarios() {
    if(this.ativarCamposUsuario){
      if(this.form?.dataInicio.value == null){
        this.toastr.warning("Favor informar a data de início.");
        this.spinnerService.hide();
        return;
      }
      this.spinnerService.show();
      const parametros = this.SetParametros();
      if(this.form?.dataFim.value == null)
        parametros.dataFim = new Date();
      const result = await lastValueFrom(this.relatorioService.getUsuarioChamadosUnicos(parametros))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
      if(!result.isSucess){
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.usuarios = result.data;
      this.spinnerService.hide();
    }
  }

  public validaAno(data: AbstractControl<any, any>){
    const dataDoCampo = data.value;
    if(dataDoCampo){
     const ano = new Date(dataDoCampo).getFullYear();
      if(ano > this.DataAtual.getFullYear() || ano < this.DataAtual.getFullYear() - 10){
        data.setValue(null);
        this.toastr.warning("Data invalida! Selecione uma data valida para pesquisar.");
      }
    }
  }

  public async getPerfis() {
    if(this.ativarCamposUsuario){
      if(this.form?.dataInicio.value == null){
        this.toastr.warning("Favor informar a data de início.");
        this.spinnerService.hide();
        return;
      }
      this.spinnerService.show();
      const parametros = this.SetParametros();
      if(this.form?.dataFim.value == null)
        parametros.dataFim = new Date();
      const result = await lastValueFrom(this.relatorioService.getPerfisChamadosUnicos(parametros))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
      if(!result.isSucess){
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }
      this.perfis = result.data;
      this.spinnerService.hide();
    }
  }

  public async RelatorioConsolidadoGeral(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }
    const parametros = this.SetParametros();
    const response = await lastValueFrom(this.relatorioService.getRelatorioConsolidado(parametros))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaConsolidado = response.data;
    this.excelService.exportToExcel(this.listaConsolidado, 'Consolidado', 'Relatorio', 1);
    if(this.listaConsolidado.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async RelatorioPendencias() {
    this.spinnerService.show();

    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if (this.form?.dataInicio.value == null) {
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametros();
   
    const response = await lastValueFrom(this.relatorioService.getRelatorioPendencias(parametros)).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    const pendencias = response.data;
    const cacheDiasNaoLetivos: { [key: number]: string[] } = {};

    const anoInicio = parametros.dataInicio ? new Date(parametros.dataInicio).getFullYear() : new Date().getFullYear();

    const anoFim = parametros.dataFim ? new Date(parametros.dataFim).getFullYear() : new Date().getFullYear();

    for (const pendencia of pendencias) {
      const escolaId = pendencia.codigoEscola;

      if (!cacheDiasNaoLetivos[escolaId]) {
        const diasNaoLetivosEscola: string[] = [];

        for (let ano = anoInicio; ano <= anoFim; ano++) {
          const naoLetivosResponse = await lastValueFrom(this.calendarioService.getConsultarCalendario(escolaId, ano)).catch((err) => this.ConvivaErrors.handleResultError(err));

          if (naoLetivosResponse?.isSucess) {
            for (const periodo of naoLetivosResponse.data.filter((x: any) => !x.letivo)) {
                const start = new Date(periodo.dataInicio);
                const end = periodo.dataFim ? new Date(periodo.dataFim) : new Date(periodo.dataInicio);

                const current = new Date(start);
                while (current <= end) {
                  diasNaoLetivosEscola.push(this.formatDateBR(new Date(current)));
                  current.setDate(current.getDate() + 1); // avança 1 dia
                }
              }
          }
        }

        cacheDiasNaoLetivos[escolaId] = diasNaoLetivosEscola;
      }

      let datasPendencias = (pendencia.pendenciasPreenchimento ?? "").split("-").map((x: string) => x.trim()).filter((x: string) => x !== "");

      datasPendencias = datasPendencias.map((d: string) => {
        const [dia, mes, ano] = d.split("/");
        return this.formatDateBR(new Date(+ano, +mes - 1, +dia));
      });

      datasPendencias = datasPendencias.filter(
        (d: string) => !cacheDiasNaoLetivos[escolaId].includes(d)
      );

      pendencia.pendenciasPreenchimento = datasPendencias.join(" - ");
    }

    this.listaPendencias = pendencias;
    const dadosExportar = this.listaPendencias.map((p: any) => ({
      "DIRETORIA DE ENSINO": p.nomeDiretoria,
      "ESCOLA": p.nomeEscola,
      "Nº DE OCORRÊNCIAS": p.numeroOcorrencias,
      "Nº DE NÃO OCORRÊNCIAS": p.numeroNaoOcorrencias,
      "% DE PENDÊNCIA DE PREENCHIMENTO DO SISTEMA (NÚMERO TOTAL DE DIAS MENOS OS DIAS REGISTRADOS COM OCORRÊNCIA OU NÃO OCORRÊNCIA)": p.porcentagemNaoPreenchimento,
      "PENDÊNCIAS DE PREENCHIMENTO": p.pendenciasPreenchimento
    }));

    this.excelService.exportToExcel(dadosExportar, "Pendencias", "Relatorio", 2);

    const todasSemPendencias = this.listaPendencias.every(
      (p: any) => !p.pendenciasPreenchimento || p.pendenciasPreenchimento.trim() === ""
    );

    if (todasSemPendencias) {
      this.toastr.warning("Não existem dados para essa pesquisa");
    }

    this.spinnerService.hide();
  }


  public async RelatorioVisitaPsicologo(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametros();

    const response = await lastValueFrom(this.relatorioService.getRelatorioVisitaPsicologo(parametros))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaVisitasPsicologos = response.data;
    if(this.listaVisitasPsicologos.length != 0)
      this.excelService.exportToExcel(this.listaVisitasPsicologos, 'Visitas Psicologos', 'Relatorio', 3);

    if(this.listaVisitasPsicologos.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async RelatorioChamadosUsuario(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }
    const parametros = this.SetParametros();

    if(this.form?.dataFim.value == null)
      parametros.dataFim = new Date();

    const response = await lastValueFrom(this.relatorioService.getRelatorioChamadosUsuario(parametros))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaChamadoUsuario = response.data;
    this.excelService.exportToExcel(this.listaChamadoUsuario, 'Chamados por Usuario', 'Relatorio', 4);
    if(this.listaChamadoUsuario.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async RelatorioOcorrenciasAtivas(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataFim.value == null){
      this.form?.dataFim.setValue(formatDate(Date(),'yyyy-MM-dd',this.locale));
    }

    const dataInicio = new Date(this.form?.dataInicio.value);
    const dataFim = new Date(this.form?.dataFim.value);
    if(dataFim < dataInicio){
      this.toastr.warning("A data fim deve ser maior ou igual à data de início.");
      this.spinnerService.hide();
      return;
    }

    const periodoMaximoDias = 366;
    const periodoDias = Math.floor((dataFim.getTime() - dataInicio.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    if(periodoDias > periodoMaximoDias){
      this.toastr.warning(`O período informado não pode ser superior a ${periodoMaximoDias} dias. Refine os filtros de data para executar o relatório.`);
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametros();
    const response = await lastValueFrom(this.relatorioService.getRelatorioOcorrenciasAtivas(parametros))
      .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaOcorrenciasAtivas = response.data;
    this.excelService.exportToExcel(this.listaOcorrenciasAtivas, 'Ocorrencias Ativas', 'Relatorio', 5);
    if(this.listaOcorrenciasAtivas.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async RelatorioCalculoUsabilidade(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }
    const parametros = this.SetParametros();

    if(this.form?.dataFim.value == null)
      parametros.dataFim = new Date();
    const response = await lastValueFrom(this.relatorioService.getRelatorioCalculoUsabilidade(parametros))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaCalculoUsabilidade = response.data;
    this.excelService.exportToExcel(this.listaCalculoUsabilidade, 'Calculo Usabilidade', 'Relatorio', 6);
    if(this.listaCalculoUsabilidade.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async RelatorioLogVinculoPlanosPMCE(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }
    const somenteDivergencia = this.form?.somenteDivergencia.value === true;
    const parametros = this.SetParametros();
    if(this.form?.dataFim.value == null)
      parametros.dataFim = new Date();

    const response = await lastValueFrom(this.relatorioService.getRelatorioLogVinculoPlanosPMCE(parametros))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaLogVinculoPlanoMelhoria = response.data;

    const dadosExportar = this.listaLogVinculoPlanoMelhoria.map((x: any) => {
      const linha: Record<string, unknown> = {
        "ID DO PLANO": x.codigoPlanoMelhoria,
        "DIRETORIA": x.nomeDiretoriaAtual,
        "ESCOLA": x.nomeEscolaAtual ? `${x.codigoEscolaAtual} - ${x.nomeEscolaAtual}` : x.codigoEscolaAtual,
        "DATA OPERAÇÃO": x.dataOperacao,
        "TIPO AÇÃO": `${x.tipoAcao ?? ""}${x.tipoAcao ? " - " : ""}${this.getDescricaoTipoAcaoLog(x.tipoAcao)}`,
        "USUÝRIO": x.nomeUsuario,
        "PERFIL": x.nomePerfil,
        "DESCRIÇÃO AÇÃO": x.descricaoAcao
      };
      if (somenteDivergencia) {
        linha["ESCOLA DE ORIGEM (CORRETO)"] = x.escolaOrigemCorreta;
        linha["ESCOLA ATUAL (INCORRETO)"] = x.escolaAtualIncorreta;
      }
      return linha;
    });

    this.excelService.exportToExcel(dadosExportar, 'Logs Vinculo PMCE', 'Relatorio', 7);

    if(this.listaLogVinculoPlanoMelhoria.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async RelatorioStatusPMCE(){
    this.spinnerService.show();
    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if(this.form?.dataInicio.value == null){
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametros();
    if(this.form?.dataFim.value == null)
      parametros.dataFim = new Date();

    const response = await lastValueFrom(this.relatorioService.getRelatorioStatusPMCE(parametros))
    .catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.listaStatusPMCE = response.data;

    const dadosExportar = this.listaStatusPMCE.map((x: ListarStatusPMCE) => ({
      "URE": x.nomeDiretoria,
      "ESCOLA": x.nomeEscola,
      "STATUS": x.statusDescricao,
      "POSSUI EVIDÊNCIA": x.possuiEvidencia,
      "QUANTIDADE DE ANEXOS": x.quantidadeAnexos,
      "AÇÕES COM EVIDÊNCIA": `${x.quantidadeAcoesComEvidencia}/${x.quantidadeAcoes} ações`,
      "ANO LETIVO": x.anoLetivo,
      "DATA DE INCLUSÃO": x.dataInclusao ? this.formatDateBR(new Date(x.dataInclusao)) : '',
      "DATA DA EXTRAÇÃO": x.dataExtracao ? this.formatDateBR(new Date(x.dataExtracao)) : '',
    }));

    this.excelService.exportToExcel(dadosExportar, 'Status PMCE', 'Relatorio', 9);

    if(this.listaStatusPMCE.length == 0){
      this.toastr.warning("Não existem dados para essa pesquisa");
      return;
    }
    this.spinnerService.hide();
  }

  public async DiagnosticoDataRegistroOrfa() {
    this.spinnerService.show();
    this.ativarPainelDataRegistroOrfa = true;
    this.resumoDataRegistroOrfa = null;
    this.listaDataRegistroOrfa = [];

    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if (this.form?.dataInicio.value == null) {
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametros();
    const response = await lastValueFrom(this.relatorioService.getDiagnosticoDataRegistroOrfa(parametros))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? "Erro ao consultar diagnóstico.");
      this.spinnerService.hide();
      return;
    }

    this.resumoDataRegistroOrfa = response.data?.resumo ?? null;
    this.listaDataRegistroOrfa = response.data?.candidatos ?? [];

    if (this.listaDataRegistroOrfa.length === 0) {
      this.toastr.info("Nenhuma atividade órfã encontrada no período.");
    } else {
      this.toastr.success(`${this.listaDataRegistroOrfa.length} atividade(s) candidata(s) à correção.`);
    }

    this.spinnerService.hide();
  }

  public ExportarDataRegistroOrfa() {
    if (!this.listaDataRegistroOrfa?.length) {
      this.toastr.warning("Execute o diagnóstico antes de exportar.");
      return;
    }

    const dadosExportar = this.listaDataRegistroOrfa.map((x) => ({
      "JORNADA": x.codigoJornada,
      "ATIVIDADE": x.codigoAtividade,
      "TÝTULO": x.titulo,
      "TIPO": x.tipoAtividadeDescricao,
      "DATA VISITA": x.dataAtividade,
      "DATA JORNADA": x.dataJornada,
      "URE": x.nomeDiretoria,
      "ESCOLA": x.nomeEscola,
      "TEMPO REGISTRO": x.tempoRegistro,
      "HIPÓTESE": x.hipotese
    }));

    this.excelService.exportToExcel(dadosExportar, 'Data Registro Orfa', 'Relatorio', 8);
    this.toastr.success("Exportação gerada com sucesso.");
  }

  public CorrigirDataRegistroOrfa() {
    if (!this.listaDataRegistroOrfa?.length) {
      this.toastr.warning("Execute o diagnóstico antes de corrigir.");
      return;
    }

    this.showModalConfirmacaoCorrecao = true;
  }

  public FecharModalConfirmacaoCorrecao() {
    this.showModalConfirmacaoCorrecao = false;
  }

  public async ConfirmarCorrecaoDataRegistroOrfa() {
    this.showModalConfirmacaoCorrecao = false;
    this.spinnerService.show();
    const parametros = this.SetParametros();
    parametros.codigoUsuario = this.userLogado?.codigoUsuario ?? 0;
    parametros.nomeUsuario = this.userLogado?.nome ?? "TELA_RELATORIOS_169063";

    const response = await lastValueFrom(this.relatorioService.setCorrigeDataRegistroOrfa(parametros))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? "Erro ao aplicar correção.");
      this.spinnerService.hide();
      return;
    }

    this.toastr.success(response.message || "Correção aplicada.");
    this.spinnerService.hide();
    await this.DiagnosticoDataRegistroOrfa();
  }

  public get totalDuplicatasSelecionadas(): number {
    return this.listaDuplicatasPrevencaoPoc?.filter(x => x.selecionado).length ?? 0;
  }

  public async DiagnosticoDuplicatasVisitaPrevencaoPoc() {
    if (this.userLogado?.codigoPerfil != Perfil.GestorConviva) {
      this.toastr.error("Acesso permitido apenas ao perfil Gestor Conviva.");
      return;
    }

    this.spinnerService.show();
    this.ativarPainelDuplicatasPrevencaoPoc = true;
    this.resumoDuplicatasPrevencaoPoc = null;
    this.listaDuplicatasPrevencaoPoc = [];
    this.selecionarTodosDuplicatas = false;

    if (this.formRelatorios.invalid) {
      this.spinnerService.hide();
      return;
    }
    if (this.form?.dataInicio.value == null) {
      this.toastr.warning("Favor informar a data de início.");
      this.spinnerService.hide();
      return;
    }

    const parametros = this.SetParametros() as any;
    parametros.codigoPerfil = this.userLogado?.codigoPerfil ?? 0;
    parametros.incluirAprovados = this.incluirAprovadosDuplicatas === true;

    const response = await lastValueFrom(this.relatorioService.getDiagnosticoDuplicatasVisitaPrevencaoPoc(parametros))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? "Erro ao consultar duplicados.");
      this.spinnerService.hide();
      return;
    }

    this.resumoDuplicatasPrevencaoPoc = response.data?.resumo ?? null;
    this.listaDuplicatasPrevencaoPoc = (response.data?.candidatos ?? []).map((item: DiagnosticoDuplicatasVisitaPrevencaoPocItem) => ({
      ...item,
      selecionado: !item.manterSugerido
    }));
    this.atualizarFlagSelecionarTodosDuplicatas();

    if (this.listaDuplicatasPrevencaoPoc.length === 0) {
      this.toastr.info("Nenhum duplicado de Visita de Prevenção POC encontrado no período.");
    } else {
      this.toastr.success(`${this.listaDuplicatasPrevencaoPoc.length} registro(s) candidato(s) a duplicata.`);
    }

    this.spinnerService.hide();
  }

  public toggleSelecionarTodosDuplicatas() {
    this.selecionarTodosDuplicatas = !this.selecionarTodosDuplicatas;
    this.listaDuplicatasPrevencaoPoc.forEach(item => item.selecionado = this.selecionarTodosDuplicatas);
  }

  public onSelecaoDuplicataAlterada() {
    this.atualizarFlagSelecionarTodosDuplicatas();
  }

  private atualizarFlagSelecionarTodosDuplicatas() {
    this.selecionarTodosDuplicatas = this.listaDuplicatasPrevencaoPoc.length > 0
      && this.listaDuplicatasPrevencaoPoc.every(x => !!x.selecionado);
  }

  public InativarDuplicatasSelecionadas() {
    if (this.userLogado?.codigoPerfil != Perfil.GestorConviva) {
      this.toastr.error("Acesso permitido apenas ao perfil Gestor Conviva.");
      return;
    }
    if (this.totalDuplicatasSelecionadas === 0) {
      this.toastr.warning("Selecione ao menos um registro para inativar.");
      return;
    }
    this.showModalConfirmacaoInativacaoDuplicatas = true;
  }

  public FecharModalConfirmacaoInativacaoDuplicatas() {
    this.showModalConfirmacaoInativacaoDuplicatas = false;
  }

  public async ConfirmarInativacaoDuplicatasVisitaPrevencaoPoc() {
    this.showModalConfirmacaoInativacaoDuplicatas = false;
    this.spinnerService.show();

    const codigos = this.listaDuplicatasPrevencaoPoc
      .filter(x => x.selecionado)
      .map(x => x.codigoAtividadePoc);

    const parametros = {
      codigosAtividadePoc: codigos,
      codigoUsuario: this.userLogado?.codigoUsuario ?? 0,
      nomeUsuario: this.userLogado?.nome ?? "TELA_RELATORIOS_170918",
      codigoPerfil: this.userLogado?.codigoPerfil ?? 0,
      nomePerfil: this.userLogado?.nomePerfil ?? "Gestor Conviva"
    };

    const response = await lastValueFrom(this.relatorioService.setInativarDuplicatasVisitaPrevencaoPoc(parametros))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? "Erro ao inativar duplicados.");
      this.spinnerService.hide();
      return;
    }

    this.toastr.success(response.message || "Registros inativados.");
    this.spinnerService.hide();
    await this.DiagnosticoDuplicatasVisitaPrevencaoPoc();
  }

  private getDescricaoTipoAcaoLog(tipoAcao: number | null | undefined): string {
    switch (tipoAcao) {
      case 1: return "Inserir";
      case 2: return "Edição";
      case 3: return "Excluir";
      default: return "";
    }
  }

  public SetParametros(): Consolidado {
    const chamado = new Consolidado();
    chamado.codigoPolo = this.form?.codigoPolo.value == null ? 0 : this.form?.codigoPolo.value;
    chamado.codigoDiretoria = this.form?.codigoDiretoria.value == null ? 0 : this.form?.codigoDiretoria.value;
    chamado.codigoEscola = this.form?.codigoEscola.value == null ? 0 : this.form?.codigoEscola.value;
    chamado.codigoSubCategoria = this.form?.codigoSubCategoria.value == null ? 0 : this.form?.codigoSubCategoria.value;
    chamado.codigoPerfil = this.form?.codigoPerfil.value == null ? 0 : this.form?.codigoPerfil.value;
    chamado.codigoUsuario = this.form?.cpf.value == null ? 0 : this.form?.cpf.value;
    chamado.codigoAtivo = this.form?.codigoAtivo.value;
    chamado.somenteDivergencia = this.form?.somenteDivergencia.value === true;
    chamado.statusPlanoMelhoria = this.form?.statusPlanoMelhoria.value;
    chamado.dataInicio = this.form?.dataInicio.value;
    chamado.dataFim = this.form?.dataFim.value == null ? formatDate(Date(),'yyyy-MM-dd',this.locale) : this.form?.dataFim.value;
    return chamado;
  }

  gerarRelatorio() {
    const opcaoSelecionada = this.formRelatorios.get('idRelatorio')?.value;
    if(opcaoSelecionada === "relatorioGeral")
      this.RelatorioConsolidadoGeral();
    else if(opcaoSelecionada === "relatorioPendencias")
      this.RelatorioPendencias();
    else if(opcaoSelecionada === "relatorioVisitaPsicologo")
      this.RelatorioVisitaPsicologo();
    else if(opcaoSelecionada === "relatorioChamadoUsuario")
      this.RelatorioChamadosUsuario();
    else if(opcaoSelecionada === 'relatorioOcorrenciasAtivas')
      this.RelatorioOcorrenciasAtivas();
    else if(opcaoSelecionada === 'relatorioCalculoUsabilidade')
      this.RelatorioCalculoUsabilidade();
    else if(opcaoSelecionada === 'relatorioLogVinculoPlanosPMCE')
      this.RelatorioLogVinculoPlanosPMCE();
    else if(opcaoSelecionada === 'relatorioStatusPMCE')
      this.RelatorioStatusPMCE();
    else if(opcaoSelecionada === 'correcaoDataRegistroOrfa')
      this.DiagnosticoDataRegistroOrfa();
    else if(opcaoSelecionada === 'duplicadosVisitaPrevencaoPoc')
      this.DiagnosticoDuplicatasVisitaPrevencaoPoc();
    else if(opcaoSelecionada === 'correcaoCamposAcoesPmce')
      this.DiagnosticoCamposAcoesPmce();
    else if(opcaoSelecionada === 'buscaGeralJornada')
      this.BuscaGeralJornada();
  }

  onOptionsSelected() {
    const opcaoSelecionada = this.formRelatorios.get('idRelatorio')?.value;
    this.ativarPainelDataRegistroOrfa = opcaoSelecionada === 'correcaoDataRegistroOrfa';
    if (!this.ativarPainelDataRegistroOrfa) {
      this.resumoDataRegistroOrfa = null;
      this.listaDataRegistroOrfa = [];
    }
    this.ativarPainelDuplicatasPrevencaoPoc = opcaoSelecionada === 'duplicadosVisitaPrevencaoPoc';
    if (!this.ativarPainelDuplicatasPrevencaoPoc) {
      this.resumoDuplicatasPrevencaoPoc = null;
      this.listaDuplicatasPrevencaoPoc = [];
      this.selecionarTodosDuplicatas = false;
      this.incluirAprovadosDuplicatas = false;
    }
    this.ativarPainelCorrecaoCamposAcoesPmce = opcaoSelecionada === 'correcaoCamposAcoesPmce';
    if (!this.ativarPainelCorrecaoCamposAcoesPmce) {
      this.listaAcoesPmceCamposVazios = [];
    }
    this.ativarBuscaGeralJornada = opcaoSelecionada === 'buscaGeralJornada';
    if (!this.ativarBuscaGeralJornada) {
      this.listaBuscaGeralJornada = [];
    }
    if(opcaoSelecionada === "relatorioChamadoUsuario"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposUsuario = true;
      this.ativarCamposPsicologo = false;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
      this.carregarCombos();
    }else if(opcaoSelecionada === "relatorioVisitaPsicologo"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
      // this.getCategorias();
    }else if(opcaoSelecionada === "relatorioOcorrenciasAtivas"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = true;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
      this.getCategorias();
    }else if(opcaoSelecionada === "relatorioCalculoUsabilidade"){
      this.ativarCampoPolo = false;
      this.ativarCamposDiretoriaEscola = false;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
      this.getCategorias();
    }else if(opcaoSelecionada === "relatorioLogVinculoPlanosPMCE"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = true;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
      this.formRelatorios.get('somenteDivergencia')?.setValue(false);
    }else if(opcaoSelecionada === "relatorioStatusPMCE"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = true;
      this.ativarCampoPeriodo = true;
      this.formRelatorios.get('statusPlanoMelhoria')?.setValue(null);
    }else if(opcaoSelecionada === "correcaoDataRegistroOrfa"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
    }else if(opcaoSelecionada === "duplicadosVisitaPrevencaoPoc"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
    }else if(opcaoSelecionada === "correcaoCamposAcoesPmce"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = false;
    }else if(opcaoSelecionada === "buscaGeralJornada"){
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
    }else{
      this.ativarCampoPolo = true;
      this.ativarCamposDiretoriaEscola = true;
      this.ativarCamposPsicologo = false;
      this.ativarCamposUsuario = false;
      this.ativarCamposOcorrenciasAtivas = false;
      this.ativarCampoDivergenciaPmce = false;
      this.ativarCampoStatusPmce = false;
      this.ativarCampoPeriodo = true;
    }
  }

  carregarCombos(){
    this.getCategorias();
    this.getPerfis();
    this.getUsuarios();
  }

  public async DiagnosticoCamposAcoesPmce() {
    if (this.userLogado?.codigoPerfil != Perfil.GestorConviva) {
      this.toastr.error("Acesso permitido apenas ao perfil Gestor Conviva.");
      return;
    }

    const codigoDiretoria = Number(this.form?.codigoDiretoria?.value);
    const codigoEscola = Number(this.form?.codigoEscola?.value) || 0;

    if (!codigoDiretoria || codigoDiretoria <= 0) {
      this.toastr.warning("Selecione a URE.");
      return;
    }

    this.spinnerService.show();
    this.ativarPainelCorrecaoCamposAcoesPmce = true;
    this.listaAcoesPmceCamposVazios = [];

    const response = await lastValueFrom(
      this.planoMelhoriaService.getPlanoMelhoriaPorDiretoriaEEscola(codigoDiretoria, codigoEscola)
    ).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? "Erro ao consultar planos PMCE.");
      this.spinnerService.hide();
      return;
    }

    const planos: PlanoMelhoria[] = response.data ?? [];
    this.listaAcoesPmceCamposVazios = this.montarListaAcoesCamposVazios(planos);

    if (this.listaAcoesPmceCamposVazios.length === 0) {
      this.toastr.info("Nenhuma ação com campos vazios (Público, Parceria, Responsável ou Bimestre) no filtro.");
    } else {
      this.toastr.success(`${this.listaAcoesPmceCamposVazios.length} ação(ões) com campo(s) vazio(s).`);
    }

    this.spinnerService.hide();
  }

  private montarListaAcoesCamposVazios(planos: PlanoMelhoria[]): AcaoPmceCampoVazioItem[] {
    const lista: AcaoPmceCampoVazioItem[] = [];

    for (const plano of planos) {
      for (const acao of plano.acoes ?? []) {
        const publicoEditavel = !this.isPublicoPreenchido(acao.publico);
        const responsavelEditavel = !this.isTextoPreenchido(acao.responsavel);
        const parceriaValor = (acao.outraParceria || acao.parceria || '').trim();
        const outraParceriaEditavel = !parceriaValor;
        const bimestreEditavel = !this.isBimestrePreenchido(acao.bimestre);

        if (!publicoEditavel && !responsavelEditavel && !outraParceriaEditavel && !bimestreEditavel) {
          continue;
        }

        lista.push({
          codigoPlanoMelhoria: plano.codigoPlanoMelhoria,
          nomeEscola: plano.nomeEscola,
          codigoPlanoMelhoriaAcao: acao.codigoPlanoMelhoriaAcao,
          temaResumo: (acao.tema || '').substring(0, 120),
          publico: publicoEditavel ? null : Number(acao.publico),
          responsavel: responsavelEditavel ? '' : (acao.responsavel || ''),
          outraParceria: outraParceriaEditavel ? '' : parceriaValor,
          bimestre: bimestreEditavel ? null : Number(acao.bimestre),
          publicoEditavel,
          responsavelEditavel,
          outraParceriaEditavel,
          bimestreEditavel,
        });
      }
    }

    return lista;
  }

  private isTextoPreenchido(valor: string | null | undefined): boolean {
    return !!(valor && String(valor).trim());
  }

  private isPublicoPreenchido(valor: unknown): boolean {
    const n = Number(valor);
    return Number.isFinite(n) && n >= 1 && n <= 6;
  }

  private isBimestrePreenchido(valor: unknown): boolean {
    const n = Number(valor);
    return Number.isFinite(n) && n >= 1 && n <= 4;
  }

  public nomePublicoPmce(id: number | null): string {
    if (!id) return '—';
    return this.publicoOpcoesPmce.find(p => p.id === id)?.name ?? String(id);
  }

  public nomeBimestrePmce(id: number | null): string {
    if (!id) return '—';
    return this.bimestreOpcoesPmce.find(b => b.id === id)?.name ?? String(id);
  }

  private formatDateBR(date: Date): string {
    const dia = String(date.getDate()).padStart(2, "0");
    const mes = String(date.getMonth() + 1).padStart(2, "0");
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  private numeroFiltro(valor: unknown): number | null {
    const numero = Number(valor);
    return Number.isFinite(numero) && numero > 0 ? numero : null;
  }

  public async BuscaGeralJornada() {
    const codigoJornada = this.numeroFiltro(this.form?.codigoJornada?.value);
    const codigoDiretoria = this.numeroFiltro(this.form?.codigoDiretoria?.value)
      ?? this.numeroFiltro(this.form?.codigoDiretoriaLivre?.value);
    const codigoEscola = this.numeroFiltro(this.form?.codigoEscola?.value)
      ?? this.numeroFiltro(this.form?.codigoEscolaLivre?.value);
    const cpf = (this.form?.cpfBusca?.value ?? '').toString().trim();
    const dataInicio = this.form?.dataInicio?.value || null;
    const dataFim = this.form?.dataFim?.value || null;

    if (!codigoJornada && !codigoDiretoria && !codigoEscola && !cpf && !dataInicio && !dataFim) {
      this.toastr.warning("Informe ao menos um filtro: jornada, data, CPF, escola ou URE.");
      return;
    }

    this.spinnerService.show();
    this.listaBuscaGeralJornada = [];

    const response = await lastValueFrom(this.relatorioService.getBuscaGeralJornada({
      codigoJornada,
      codigoDiretoria,
      codigoEscola,
      cpf: cpf || null,
      dataInicio,
      dataFim
    })).catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response?.isSucess) {
      this.toastr.error(response?.message ?? "Erro ao buscar jornadas.");
      this.spinnerService.hide();
      return;
    }

    this.listaBuscaGeralJornada = response.data ?? [];
    if (this.listaBuscaGeralJornada.length === 0) {
      this.toastr.warning("Não existem dados para essa pesquisa");
    }

    this.spinnerService.hide();
  }

  public ExportarBuscaGeralJornada() {
    const dados = this.listaBuscaGeralJornada.map((item) => ({
      "Jornada": item.codigoJornada,
      "CPF": item.cpf,
      "Nome": item.nome,
      "Polo": item.codigoPolo,
      "URE": item.codigoDiretoria,
      "Nome URE": item.nomeDiretoria,
      "Escola": item.codigoEscola,
      "Nome escola": item.nomeEscola,
      "Início": item.dataInicio,
      "Fim": item.dataFim,
      "Exclusão": item.dataExclusao,
      "Aprovação": item.statusAprovacao,
      "Coordenador": item.flCoordenador ? "Sim" : "Não",
      "Psicólogo ativo": item.flAtivo
    }));
    this.excelService.exportToExcel(dados, "Busca geral de jornada", "Relatorio", 2);
  }

  public statusJornadaBusca(item: BuscaGeralJornadaItem): string {
    if (item.dataExclusao) {
      return "Excluída";
    }
    if (item.statusAprovacao === 1) {
      return "Validado";
    }
    return "Não validado";
  }

}
